// extracted by mini-css-extract-plugin
module.exports = {"main":"arrow_main__fbmXt","content":"arrow_content__I08am","arrowLeft":"arrow_arrowLeft__GXfQZ","arrowRight":"arrow_arrowRight__xqSI4"};